import { useCallback } from 'react';
import { SPECIAL_SPACE_ID } from 'src/common/const';
import { useRefreshUnreadState } from 'src/views/main/aside/message-panel/shared';
// 获取使用秘笈未读个数
export const useGetUnreadCount = () => {
  const refreshUnreadState = useRefreshUnreadState();

  return useCallback(async () => {
    const { results } = await refreshUnreadState(SPECIAL_SPACE_ID);

    const result = {
      strategyGuides: 0,
      messageBoard: 0,
      mentions: 0,
      subscribe: 0,
    };

    results?.forEach(({ unread }) => {
      if (unread?.mentions) {
        result.mentions = unread?.mentions;
      }
      if (unread?.strategyGuides) {
        result.strategyGuides = unread?.strategyGuides;
      }
      if (unread?.messageBoard) {
        result.messageBoard = unread?.messageBoard;
      }
      if (unread?.subscribe) {
        result.subscribe = unread?.subscribe;
      }
    });

    return result;
  }, [refreshUnreadState]);
};
